import { render } from "./JobPostAlertSubscriptionComponent.vue?vue&type=template&id=66002537&scoped=true"
import script from "./JobPostAlertSubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./JobPostAlertSubscriptionComponent.vue?vue&type=script&lang=js"

import "./JobPostAlertSubscriptionComponent.vue?vue&type=style&index=0&id=66002537&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66002537"]])

export default __exports__